import type { FormButtonSettingsFormGroupType } from '@components/sp-form-button-settings';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { isEmptyButtonLabel } from '@common/helpers/forms';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import { TranslateModule } from '@ngx-translate/core';
import { SpFormButtonSettingsModule } from '@components/sp-form-button-settings/src/sp-form-button-settings.module';
import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';

@Component({
    selector: 'web-shop-cart-form-button-settings',
    templateUrl: './shop-cart-form-button-settings.component.html',
    styleUrls: ['./shop-cart-form-button-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WebSettingsModule, SpFormButtonSettingsModule, TranslateModule],
})
export class ShopCartFormButtonSettingsComponent extends WebBaseControlTypedSettingsComponent<FormButtonSettingsFormGroupType> {
    @Input() public isHorizontalForm: boolean;

    public get saveDisablePredicate(): boolean {
        return isEmptyButtonLabel(this.itemForm?.controls.label?.value);
    }
}
